import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../hooks/useUser";
import LoadingComponent from "./form-components/LoadingComponent";
import * as authStorage from "../lib/authStorage";

const AuthWrapper = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const { user, loading, logout } = useUser();
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

  useEffect(() => {
    if (loading) {
      return;
    }

    const accessToken = authStorage.getAccessToken();

    if (!accessToken) {
      navigate("/login", { replace: true });
      return;
    }

    if (!user) {
      logout();
      navigate("/login", { replace: true });
      return;
    }

    const isAdmin = user.type.toLowerCase() === "admin";
    if (isAdmin) {
      setIsAuthorized(true);
    } else {
      logout();
      navigate("/login", { replace: true });
    }
  }, [user, loading, navigate, logout]);

  if (loading || !isAuthorized) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        <LoadingComponent />
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthWrapper;
